module.exports = __webpack_public_path__ + "img/waist.6b72d110.png";